//UI
export const DISPLAY_ALERT = "SHOW_ALERT";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const SELECT_TABLE = "SELECT_TABLE";

//loading

export const LOADING_BEGIN = "LOADING_BEGIN";
export const LOADING_SUCCESS = "LOADING_SUCCESS";

// Item

//Basket
export const UPDATE_PRICE = "UPDATE_PRICE";
export const CLEAR_BASKET = "CLEAR_BASKET";

// BasketItem
export const UPDATE_DESC = "UPDATE_DESC";
export const DELETE_ITEM = "DELETE_ITEM";
export const CHANGE_ITEMS = "CHANGE_ITEMS";
export const ADD_ITEM = "ADD_ITEM";
export const CHANGE_TYPE = "CHANGE_TYPE";
export const UPDATE_QTY = "UPDATE_QTY";

//Table

export const LOADING_TABLE_BEGIN = "LOADING_TABLE_BEGIN";
export const LOADING_TABLE_SUCCESS = "LOADING_TABLE_SUCCESS";
export const LOADING_TABLE_ERROR = "LOADING_TABLE_ERROR";
export const TOGGLE_TABLE_MENU = "TOGGLE_TABLE_MENU";

//Table - save

export const TABLE_SAVING_BEGIN = "TABLE_SAVING_BEGIN";
export const TABLE_SAVING_SUCCESS = "TABLE_SAVING_SUCCESS";
export const TABLE_SAVING_ERROR = "TABLE_SAVING_ERROR";

//Menu Items

export const LOADING_ITEMS_BEGIN = "LOADING_ITEMS_BEGIN";
export const LOADING_ITEMS_SUCCESS = "LOADING_ITEMS_SUCCESS";
export const LOADING_ITEMS_ERROR = "LOADING_ITEMS_ERROR";

//Login

export const LOGIN_USER_BEGIN = "LOGIN_USER_BEGIN";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";

//User

export const GET_CURRENT_USER_BEGIN = "GET_CURRENT_USER_BEGIN";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const LOGOUT_USER = "LOGOUT_USER";

//Admin - Users

export const LOADING_USERS_BEGIN = "LOADING_USERS_BEGIN";
export const LOADING_USERS_SUCCESS = "LOADING_USERS_SUCCESS";
export const LOADING_USERS_ERROR = "LOADING_USERS_ERROR";

export const ADD_USER_BEGIN = "ADD_USER_BEGIN";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_ERROR = "ADD_USER_ERROR";

export const EDIT_USER_BEGIN = "EDIT_USER_BEGIN";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";

//Payment

export const TOGGLE_PAYMENT_SCREEN = "TOGGLE_PAYMENT_SCREEN";
export const PROCESS_PAYMENT_BEGIN = "PROCESS_PAYMENT_BEGIN";
export const PROCESS_PAYMENT_SUCCESS = "PROCESS_PAYMENT_SUCCESS";
